import type { TFunction } from 'i18next';

export const getWidgetNotices = (t: TFunction) => ({
  errorNotice: t("We couldn't display this data."),
  emptyNotice: t('No data.'),
});
